import { render, staticRenderFns } from "./pindaan-c.vue?vue&type=template&id=8c0a2548&"
import script from "./pindaan-c.vue?vue&type=script&lang=js&"
export * from "./pindaan-c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports